/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { ApiCreateDemoDtoV2, ApiDemoBookedDto, ApiUpdateDemoDtoV2, DemoDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiDemoControllerV2<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-demo-controller-v-2
   * @name Create3
   * @request POST:/api/v2/demos
   */
  create = (data: ApiCreateDemoDtoV2, params: RequestParams = {}) =>
    this.http.request<DemoDto, any>({
      path: `/v2/demos`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createPath = '/v2/demos'
  static createMethod = 'POST'
  /**
   * No description
   *
   * @tags api-demo-controller-v-2
   * @name GetById5
   * @request GET:/api/v2/demos/{demoId}
   */
  getById = (demoId: string, params: RequestParams = {}) =>
    this.http.request<DemoDto, any>({
      path: `/v2/demos/${demoId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByIdPath = '/v2/demos/${demoId}'
  static getByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-demo-controller-v-2
   * @name Update6
   * @request PATCH:/api/v2/demos/{demoId}
   */
  update = (demoId: string, data: ApiUpdateDemoDtoV2, params: RequestParams = {}) =>
    this.http.request<DemoDto, any>({
      path: `/v2/demos/${demoId}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updatePath = '/v2/demos/${demoId}'
  static updateMethod = 'PATCH'
  /**
   * No description
   *
   * @tags api-demo-controller-v-2
   * @name Booked
   * @request PATCH:/api/v2/demos/{demoId}/booked
   */
  booked = (demoId: string, data: ApiDemoBookedDto, params: RequestParams = {}) =>
    this.http.request<DemoDto, any>({
      path: `/v2/demos/${demoId}/booked`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bookedPath = '/v2/demos/${demoId}/booked'
  static bookedMethod = 'PATCH'
}
